module.exports = __webpack_public_path__ + "static/media/but_class_play.7bd048db.svg";